module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/promise_13-2524de6b4548cdb2dce2880e8a850b3e.png";